document.addEventListener('DOMContentLoaded', () => {
    // === De geluiden ===
    const SOUNDS = {
      change: (window.CADANS_BASIS + 'geluid-wissel.mp3'), // ander product in de rij
      enter: (window.CADANS_BASIS + 'geluid-overgang.mp3'), // van de hero naar de tweede sectie
      benefits: (window.CADANS_BASIS + 'geluid-slides.mp3'), // overgang naar een slide
      click: (window.CADANS_BASIS + 'geluid-klik.mp3'), // menuknop en menulinks
    };

    const VOLUME = 0.5; // 0 tot 1

    // === Web Audio ===
    let ctx = null;
    const buffers = {};
    let unlocked = false;

    const initCtx = () => {
      if (ctx) return;
      ctx = new (window.AudioContext || window.webkitAudioContext)();
    };

    const loadSound = async (name, url) => {
      try {
        const res = await fetch(url);
        const arrayBuffer = await res.arrayBuffer();
        buffers[name] = await ctx.decodeAudioData(arrayBuffer);
      } catch (e) {
        console.warn('[geluid] laden mislukt', name, e);
      }
    };

    const preload = () => {
      initCtx();
      Object.entries(SOUNDS).forEach(([name, url]) => loadSound(name, url));
    };

    // Volgt de geluidsknop in de navigatie (.navbar_sound.is-muted)
    const isMuted = () => {
      const btn = document.querySelector('.navbar_sound');
      return btn ? btn.classList.contains('is-muted') : false;
    };

    const play = (name, { volume = 1, rate = 1 } = {}) => {
      if (!ctx || !buffers[name] || !unlocked || isMuted()) return;

      const source = ctx.createBufferSource();
      source.buffer = buffers[name];
      source.playbackRate.value = rate;

      const gain = ctx.createGain();
      gain.gain.value = VOLUME * volume;

      source.connect(gain).connect(ctx.destination);
      source.start(0);
    };

    // === Vrijgeven bij het eerste gebaar (autoplay-beleid) ===
    const unlock = () => {
      initCtx();
      if (ctx.state === 'suspended') ctx.resume();
      unlocked = true;
      window.removeEventListener('pointerdown', unlock);
      window.removeEventListener('touchstart', unlock);
      window.removeEventListener('keydown', unlock);
      window.removeEventListener('wheel', unlock);
    };
    window.addEventListener('pointerdown', unlock);
    window.addEventListener('touchstart', unlock);
    window.addEventListener('keydown', unlock);
    window.addEventListener('wheel', unlock);

    preload();

    // Met de hand aan te sturen: window.cadansGeluid.play('change')
    window.cadansGeluid = { play };

    // === Slot op de menunavigatie: dempt de scrollgeluiden tijdens een scrollTo uit code ===
    const nav = { lock: false, timer: null };
    const lockNav = (ms = 1800) => {
      nav.lock = true;
      clearTimeout(nav.timer);
      nav.timer = setTimeout(() => (nav.lock = false), ms);
    };

    // === 1. Geluid als er een ander product actief wordt ===
    const bindCarousel = () => {
      if (!window.carousel || !window.carousel.changed) return false;
      window.carousel.changed.connect(() => play('change'));
      return true;
    };
    if (!bindCarousel()) {
      window.addEventListener('carousel:ready', bindCarousel, { once: true });
    }

    // === 2. Geluid bij het BEGIN van de overgang van sectie 1 naar 2 ===
    const bindSectionEnter = () => {
      if (!window.lenis) return false;

      let boundary = 0; // bovenkant van sectie 2 = hoogte van sectie 1
      const computeBoundary = () => {
        const first = document.querySelector('section');
        boundary = first ? first.clientHeight : 0;
      };
      computeBoundary();
      window.addEventListener('resize', computeBoundary);

      const fireAt = () => Math.max(boundary * 0.03, 24);

      let inHome = true;
      let last = window.lenis.animatedScroll || 0;

      window.lenis.on('scroll', () => {
        const cur = window.lenis.animatedScroll;
        const goingDown = cur > last;
        const threshold = fireAt();

        if (inHome && cur >= threshold) {
          inHome = false;
          if (goingDown && !nav.lock) play('enter');
        } else if (!inHome && cur < threshold) {
          inHome = true;
        }
        last = cur;
      });

      return true;
    };
    if (!bindSectionEnter()) {
      window.addEventListener('carousel:ready', bindSectionEnter, { once: true });
    }

    // === 3. Geluid bij elke overgang naar een slide (omhoog EN omlaag) ===
    const bindBenefits = () => {
      if (!window.lenis) return false;

      const wrap = (v, min, max) => {
        const size = max - min;
        v = v % size;
        if (v < 0) v += size;
        return v + min;
      };

      let sections = [];
      const buildSections = () => {
        let top = 0;
        sections = [...document.querySelectorAll('section')].map((el) => {
          const item = { top, isBenefits: el.classList.contains('is-benefits') };
          top += el.clientHeight;
          return item;
        });
      };
      buildSections();
      window.addEventListener('resize', buildSections);

      const currentIndex = (pos) => {
        let best = 0;
        let dist = Infinity;
        sections.forEach((it, i) => {
          const d = Math.abs(it.top - pos);
          if (d < dist) {
            dist = d;
            best = i;
          }
        });
        return best;
      };

      let lastIdx = currentIndex(0);

      window.lenis.on('scroll', () => {
        const max = window.lenis.dimensions.scrollHeight - window.lenis.dimensions.height;
        if (max <= 0) return;
        const pos = wrap(window.lenis.animatedScroll, 0, max);
        const idx = currentIndex(pos);

        if (idx !== lastIdx) {
          // |delta| === 1 => sectie voor sectie (filtert de sprong van de oneindige lus eruit)
          const adjacent = Math.abs(idx - lastIdx) === 1;
          if (adjacent && sections[idx]?.isBenefits && !nav.lock) play('benefits');
          lastIdx = idx;
        }
      });

      return true;
    };

    if (!bindBenefits()) {
      window.addEventListener('carousel:ready', bindBenefits, { once: true });
    }

    // === 4. Geluid bij een klik op de menuknop en de menulinks ===
    const initMenuClicks = () => {
      document.querySelector('.navbar_menu-button')?.addEventListener('click', () => play('click'));

      document.querySelectorAll('.navbar_link').forEach((link) => {
        link.addEventListener('click', () => {
          play('click'); // alleen het klikgeluid
          lockNav(); // dempt de scrollgeluiden zolang het scrollen duurt
        });
      });

      // Slide-navigatie: geluid plus slot (scrollTo naar een slide)
      document.querySelectorAll('.benefits_icon-wrapper').forEach((icon) => {
        icon.addEventListener('click', () => {
          play('benefits');
          lockNav();
        });
      });

      // FAQ: alleen geluid (uitklappen, geen scroll)
      document.querySelectorAll('.faq_question').forEach((q) => {
        q.addEventListener('click', () => play('click'));
      });
    };
    initMenuClicks();
  });
